import localforage from "localforage";

export async function logout () {
    await localforage.setItem("nakamian.admin-token", "");
}

export default logout;
